<script>
import CustomDialog from "@/components/_Shared/Dialog";
import orderMixin from "@/mixins/orderMixin";

export default {
  mixins: [orderMixin],
  props: {
    payable: [Object],
    visible: [Boolean]
  },
  components: {
    CustomDialog
  },
  computed: {
    displayPaymentVoucherNotice() {
      let startsAt =
        this.payable.starts_at || this.payable.schedule_event.starts_at;

      return this.isInPeriodOfProofPayment(startsAt);
    }
  }
};
</script>

<template>
  <custom-dialog
    icon="/static/boleto.svg"
    title="Você quer mesmo gerar o boleto?"
    :visible="visible"
  >
    <template slot="body">
      <p>Ao gerar o boleto não será mais possível pagar pelo cartão de crédito!</p>

      <template v-if="displayPaymentVoucherNotice">
        <hr />
        <small>Você deverá enviar o comprovante de pagamento através de ticket pois o seu pedido tem menos de {{daysToProvePayment}} dias úteis de antecedência.</small>
      </template>

      <div class="btn-group">
        <div class="btn bg-purple-outline" @click="$emit('cancelled')">Não, quero voltar</div>
        <div class="btn bg-purple" @click="$emit('confirmed')">Sim, quero gerar o boleto</div>
      </div>
    </template>
  </custom-dialog>
</template>

<style scoped>
.content {
  max-width: calc(100vw - 20px);
  max-height: calc(100vh - 20px);
  background-color: #fff;
  border-radius: 4px;
}

.header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: 2px solid #f7f7f9;
  padding: 20px 20px 10px 20px;
}

.body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px 20px 30px 20px;
  background-color: #f9f9fb;
  text-align: center;
}

h1 {
  text-align: center;
  font-weight: 400;
  color: var(--purple);
}

p {
  margin-bottom: 5px;
}

small {
  color: var(--pink);
}

hr {
  width: 50px;
  background-color: transparent;
  border: 1px solid var(--pink);
  border-bottom: none;
  opacity: 0.5;
}

.btn-group {
  margin-top: 10px;
}

@media (min-width: 321px) {
  .header {
    padding: 40px 20px 10px 20px;
  }

  .body {
    padding: 10px 20px 30px 20px;
  }
}

@media (min-width: 768px) {
  .content {
    max-width: 650px;
  }

  .header {
    padding: 40px 80px 10px 80px;
  }

  .body {
    padding: 10px 80px 30px 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Checkout/Payment/BoletoConfirmation.vue